





























































































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import SideBar from "@/zh-website/src/components/website/SideBar.vue";
import Banner from "@/zh-website/src/components/website/Swiper/Banner.vue";
import { CommonService } from "@/zh-website/src/views/Enterprise/service/CommonService";

@Component({
  components: {
    SideBar,
    Banner
  }
})
export default class ProductSolution extends Vue {
  navigationName = "" as any;
  classifyName = "" as any;
  classifyLink = "" as any;
  navigationLink = "" as any;
  contentList: any[] = [];

  list = {
    style: {
      "background-image": `url(${require("../../../../assets/product-solution.jpg")})`,
      height: "493px"
    },
    font1: "",
    font2: "",
    font3: "",
    font4: "",
    font5: "",
    button: ""
  };
  mounted() {
    this.getAllNavigation();
    this.getSolutionDetail();
  }
  getSolutionDetail() {
    CommonService.getSolutionDetail({ id: this.$route.params.id })
      .then((res: any) => {
        this.contentList = res.data.contentList;
      })
      .then(() => {
        // console.log(this.contentList[0].targetStudent);
      });
  }
  getAllNavigation() {
    CommonService.getAllClassification({}).then((res: any) => {
      res.data[1].child.forEach((item: any) => {
        if (item.child) {
          item.child.forEach((element: any) => {
            if (element.id == this.$route.params.id) {
              this.classifyName = item.name;
              this.navigationName = res.data[2].name;
              this.navigationLink = "/enterprise/product/page";
              this.classifyLink = `/enterprise/product/classify/${item.id}`;
            }
          });
        }
      });
    });
  }
  toChinesNum(num) {
    if (num == 10) return "十";
    const changeNum = [
      "零",
      "一",
      "二",
      "三",
      "四",
      "五",
      "六",
      "七",
      "八",
      "九"
    ]; //changeNum[0] = "零"
    const unit = ["", "十", "百", "千", "万"];
    num = parseInt(num);
    const getWan = temp => {
      const strArr = temp
        .toString()
        .split("")
        .reverse();
      let newNum = "";
      for (let i = 0; i < strArr.length; i++) {
        newNum =
          (i == 0 && strArr[i] == 0
            ? ""
            : i > 0 && strArr[i] == 0 && strArr[i - 1] == 0
            ? ""
            : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i])) +
          newNum;
      }
      return newNum;
    };
    const overWan = Math.floor(num / 10000);
    let noWan = (num % 10000) + "";
    if (noWan.toString().length < 4) noWan = "0" + noWan;
    return overWan ? getWan(overWan) + "万" + getWan(noWan) : getWan(num);
  }
}
